import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router';
import ShopMainLayout from '../components/ShopMainLayout';
import WithTimeUrlPattern from '../hoc/WithTimeUrlPattern';
import PickTime from './time/PickTime';
import Barbers from './time/DynamicBarbers';
import Services from './time/Services';
import MakeReservation from '../reservation/MakeReservation';
import { getTimeUrls } from '../utils/helpers';


export default (urlPattern) => {
  const urls = getTimeUrls(urlPattern);

  return (
    <Route component={WithTimeUrlPattern(ShopMainLayout)}>
      <Route
        path={urls.pickTime}
        component={WithTimeUrlPattern(PickTime)}
        ignoreScrollBehavior
      />
      <Route path={urls.barbers} component={WithTimeUrlPattern(Barbers)}>
        <Route
          path={urls.services}
          component={WithTimeUrlPattern(Services)}
          ignoreScrollBehavior
        />
      </Route>
      <Route
        path={urls.makeReservation}
        component={WithTimeUrlPattern(MakeReservation)}
      />
      <Redirect
        from={`${urls.makeReservation}/**`}
        to={urls.makeReservation}
      />
    </Route>
  );
};




// WEBPACK FOOTER //
// ./src/app/dynamicBooking/TimeRoutes.jsx